export default __webpack_public_path__ + "static/hfeatures-1-50ac9dde8118df16622442fb747557a4.png";